import { connect } from 'react-redux';

// ICONS
import ICONS from '@automotivetech/icons/dist/static/media/icons.svg';
// WhatCar? Logo
import whatcarLogo from '@automotivetech/icons/dist/static/media/whatcar_logo_red.svg';

// HOC the set the theme
import withTheme from '@automotivetech/withtheme/dist/index.js';
// Footer
import FooterWc from '@automotivetech/footernewwc/dist/';
import footerWcStyle from '@automotivetech/footernewwc/dist/static/media/index.css';

// Header
import HeaderWc from '@automotivetech/headernewwc/dist/';
import headerWcStyle from '@automotivetech/headernewwc/dist/static/media/index.css';

footerWcStyle.accordionIcon = {
  iconOpen: `${ICONS}#wci-arrow-up`,
  iconClosed: `${ICONS}#wci-arrow-down`
};
footerWcStyle.iconSvg = ICONS;
footerWcStyle.style = footerWcStyle;
const FooterWcWC = withTheme(FooterWc, footerWcStyle);

headerWcStyle.iconSearch = `${ICONS}#wci-search`;
headerWcStyle.iconArrowDown = `${ICONS}#wci-arrow-down`;
headerWcStyle.iconArrowUp = `${ICONS}#wci-arrow-up`;
headerWcStyle.iconMobileMenu = `${ICONS}#wci-burger`;
headerWcStyle.iconMyDeals = `${ICONS}#wci-car`;
headerWcStyle.iconMobileMenuClose = `${ICONS}#wci-cross`;
headerWcStyle.iconAvatar = `${ICONS}#wci-avatar`;
headerWcStyle.iconHeartFilled = `${ICONS}#wci-heart-filled`;
headerWcStyle.iconHeartEmpty = `${ICONS}#wci-heart`;
headerWcStyle.iconCompare = `${ICONS}#wci-compare-icon`;
headerWcStyle.logoSVG = whatcarLogo;
headerWcStyle.style = headerWcStyle;

/**
 * Header mapStateToProps implementation
 * @param {*} state object
 * @return {object} new state object
 */
const headerMapStateToProps = state => {
  return {
    shortlistSize: state.shortlist.shortlistCmsIds.length
  };
};

const HeaderWcWC = connect(
  headerMapStateToProps,
  null,
  null
)(withTheme(HeaderWc, headerWcStyle));

export { FooterWcWC as Footer, HeaderWcWC as Header };



// WEBPACK FOOTER //
// ./src/Common/Olympus/index.js